import { CopyAnalyzeCertificate, CopyAnalyzeItem } from './pulse-api.types';

// Stable per-item keys for the cross-environment copy confirm step (TSF-1785).
//
// These live in `common/` because BOTH sides must agree exactly: the confirm UI
// builds the `confirmedKeys` array, and the server's apply matches against it.
// A drifted encoding does not error — the item is silently left uncopied — so
// there is exactly one definition and both sides import it.
//
// Not every copyable item has a key. Connection configs (ensured alongside the
// core connection) and inbound mapping rules (all-or-nothing per connection —
// see AC25) are deliberately keyless, so a confirm can never deselect them
// individually. `confirmedKeys` filters only the buckets encoded here.

export const deliveryConfigApplyKey = (accountId: string, priority: number): string =>
  `deliveryConfig:${accountId}:${priority}`;

// Outbound's namespace key is exactly its narrow unique constraint,
// UNIQUE(account_id, priority) — the slot the copy claims.
export const outboundMappingApplyKey = (accountId: string, priority: number): string =>
  `outboundMapping:${accountId}:${priority}`;

// A certificate is identified across environments by X.509 serial + fingerprint,
// scoped to the connection it hangs off. Without that connection scope there is
// no key, and the item cannot be confirmed.
export const certificateApplyKey = (item: CopyAnalyzeItem<CopyAnalyzeCertificate>): string | undefined => {
  const { source, connectionPartnerId } = item;
  if (connectionPartnerId === undefined) {
    return undefined;
  }
  const type = 'domain' in source ? 'ssl' : 'as2';
  return `certificate:${type}:${connectionPartnerId}:${source.serial_number}:${source.sha256_hash}`;
};
